import { isCustomerRole } from 'helpers/customerRole';

type HeldAccess = {
  roles?: string | null;
  permissions?: readonly string[];
};

export const adminRolesIn = (roles?: string | null) =>
  (roles ?? '')
    .split(',')
    .map(role => role.trim())
    .filter(role => role && !isCustomerRole(role));

export const lacksAdminAccess = ({ roles, permissions }: HeldAccess) =>
  adminRolesIn(roles).length === 0 || permissions?.length === 0;

export const keysLost = (
  before: readonly string[],
  after: readonly string[],
) => {
  const kept = new Set(after);
  return before.filter(key => !kept.has(key));
};

export const keysGained = (
  before: readonly string[],
  after: readonly string[],
) => keysLost(after, before);

const roleSetOf = (roles?: string | null) =>
  (roles ?? '')
    .split(',')
    .map(role => role.trim())
    .filter(Boolean)
    .sort()
    .join(',');

export const sameAccess = (a: HeldAccess, b: HeldAccess) =>
  roleSetOf(a.roles) === roleSetOf(b.roles) &&
  keysLost(a.permissions ?? [], b.permissions ?? []).length === 0 &&
  keysGained(a.permissions ?? [], b.permissions ?? []).length === 0;
